<template>
  <div class="event-sponsors">
    <h3 class="section-title">Thank you to our sponsors</h3>
    <div>
      <div
        class="row-sponsors"
        v-if="
          tiers.length > 0 && tiers[0] !== null && tiers[0].sponsors.length > 0
        "
      >
        <h6>{{ tiers[0] === null ? "" : tiers[0].name }}</h6>
        <div
          class="sponsor-images"
          v-for="(sponsor, index) in tiers[0].sponsors"
          :key="index"
          :index="index"
        >
          <a
            v-if="!sponsor.imageUrl"
            class="sponsor no-logo"
            :href="sponsor.webUrl"
          >
            <img src="@/assets/images/sponsor-logo.svg" />
            {{ sponsor.name }}
          </a>

          <a v-if="sponsor.imageUrl" :href="sponsor.webUrl">
            <div class="image-container">
              <img :src="sponsor.imageUrl" />
            </div>
            <p>{{ sponsor.name }}</p>
          </a>
        </div>
      </div>
      <div
        class="row-sponsors"
        v-if="
          tiers.length > 1 && tiers[1] !== null && tiers[1].sponsors.length > 0
        "
      >
        <h6>{{ tiers[1].name }}</h6>

        <div
          class="sponsor-images"
          v-for="(sponsor, index) in tiers[1].sponsors"
          :key="index"
          :index="index"
        >
          <a
            v-if="!sponsor.imageUrl"
            class="sponsor no-logo"
            :href="sponsor.webUrl"
          >
            <img src="@/assets/images/sponsor-logo.svg" />
            {{ sponsor.name }}
          </a>
          <a v-if="sponsor.imageUrl" :href="sponsor.webUrl">
            <div class="image-container">
              <img :src="sponsor.imageUrl" />
            </div>
            <p>{{ sponsor.name }}</p>
          </a>
        </div>
      </div>
      <div
        class="row-sponsors"
        v-if="
          tiers.length > 2 && tiers[2] !== null && tiers[2].sponsors.length > 0
        "
      >
        <h6>{{ tiers[2].name }}</h6>
        <div
          class="sponsor-images"
          v-for="(sponsor, index) in tiers[2].sponsors"
          :key="index"
          :index="index"
        >
          <a
            v-if="!sponsor.imageUrl"
            class="sponsor no-logo"
            :href="sponsor.webUrl"
          >
            <img src="@/assets/images/sponsor-logo.svg" />
            {{ sponsor.name }}
          </a>
          <a v-if="sponsor.imageUrl" :href="sponsor.webUrl">
            <div class="image-container">
              <img :src="sponsor.imageUrl" />
            </div>
            <span>{{ sponsor.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "event-sponsors",
  props: ["tiers"]
});
</script>

<style scoped>
.row-sponsors {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 2em 0;
}

.sponsor-images {
  display: flex;
}

.sponsor-images a {
  text-align: center;
  margin: 0.5rem;
  color: rgba(0, 0, 0, 0.87);
  font-weight: bold;
  font-size: 16px;
  height: 200px;
  width: 160px;
  position: relative;
}

.sponsor-images a:hover {
  text-decoration: none;
}

.sponsor-images p {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.sponsor-images .image-container {
  height: 160px;
  width: 160px;
  display: table-cell;
  vertical-align: middle;
}

.sponsor-images img {
  max-width: 160px;
  max-height: 160px;
}
</style>
